import {createSlice} from '@reduxjs/toolkit';
import {createFertility, deleteFertility, getAllFertility, getAnalysis, getFertility, updateFertility} from '../Thunk/fertiltyActions';

const fertilitySlice = createSlice({
  name: 'fertility',
  initialState: {
    fertility: [],
    analysis: [],
    patientDetails: null,
    fertilityData: {},
    editDetails: false,
    loading: false,
    error: null
  },
  reducers: {
    setEditDetails: (state, action) => {
      state.editDetails = action.payload;
    },
    setPatientDetails: (state, action) => {
      state.patientDetails = action.payload;
    },
    selectedFeritlityData: (state, action) => {
      state.fertilityData = action.payload;
    },
    reset: state => {
      state.patientDetails = null;
      state.fertilityData = {};
      state.editDetails = false;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(getAllFertility.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllFertility.fulfilled, (state, action) => {
        state.loading = false;
        state.fertility = action.payload?.data ?? [];
      })
      .addCase(getAllFertility.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message || 'Failed to fetch fertility';
      })

      .addCase(getAnalysis.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAnalysis.fulfilled, (state, action) => {
        state.loading = false;
        state.analysis = action.payload?.data ?? [];
      })
      .addCase(getAnalysis.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message || 'Failed to fetch fertility Analatics';
      })
      .addCase(getFertility.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getFertility.fulfilled, (state, action) => {
        state.loading = false;
        state.fertility = action.payload?.data ?? [];
      })
      .addCase(getFertility.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message || 'Failed to fetch fertility procedures';
      })

      .addCase(createFertility.pending, state => {
        state.loading = true;
      })
      .addCase(createFertility.fulfilled, (state, action) => {
        state.loading = false;
        // state.fertility.push(action.payload);
      })
      .addCase(createFertility.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message || 'Failed to create or update fertility procedure';
      })

      .addCase(updateFertility.pending, state => {
        state.loading = true;
      })
      .addCase(updateFertility.fulfilled, (state, action) => {
        state.loading = false;
        if (!action.payload || !action.payload.id) return; // Ensure valid data

        const index = state.fertility.findIndex(item => item.id === action.payload.id);
        if (index !== -1) {
          state.fertility[index] = action.payload; // Update item
        }
      })
      .addCase(updateFertility.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message || 'Failed to update fertility';
      })
      .addCase(deleteFertility.pending, state => {
        state.loading = true;
      })
      .addCase(deleteFertility.fulfilled, (state, action) => {
        state.loading = false;
        if (!action.payload || !action.payload.id) return; // Ensure valid ID before filtering
        console.log('action id -->', action.payload.id);

        state.fertility = state.fertility.filter(fertility => fertility.id !== action.payload.id);
      })
      .addCase(deleteFertility.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message || 'Failed to Delete fertility';
      });
  }
});

export const {setEditDetails, setPatientDetails, selectedFeritlityData, reset} = fertilitySlice.actions;
export default fertilitySlice.reducer;
